import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Send, CheckCircle2 } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import Logo from "@/components/Logo";

export default function OfficialForgotPassword() {
  const [phone, setPhone] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    const digits = phone.replace(/\D/g, "");
    if (digits.length < 10) return setError("Numéro invalide. Format attendu : 10 chiffres (Canada/É.-U.).");
    setLoading(true);
    try {
      await api.post("/auth/official/forgot-password", { phone });
      setSubmitted(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F5F5F0] flex items-center justify-center p-6" data-testid="official-forgot-page">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-8">
          <Logo size={40} />
          <span className="ml-2 badge-dark">Officiel</span>
        </div>
        <div className="card-flat">
          <div className="label mb-1">Mot de passe oublié</div>
          <h2 className="font-serif text-4xl mb-2">Réinitialisation.</h2>

          {submitted ? (
            <div className="mt-4 space-y-4" data-testid="official-forgot-success">
              <div className="border-2 border-black p-4 text-xs flex items-start gap-2">
                <CheckCircle2 size={16} strokeWidth={2.5} className="shrink-0 mt-0.5" />
                <div>
                  Si ce numéro est lié à un compte officiel, tu vas recevoir un SMS avec un lien pour réinitialiser ton mot de passe.<br />
                  Le lien expire dans <strong>15 minutes</strong>.
                </div>
              </div>
              <p className="font-mono text-[10px] uppercase tracking-widest text-[var(--muted)]">
                Rien reçu après 2 min ? Vérifie ton numéro ou demande de l'aide à ton gestionnaire.
              </p>
              <Link to="/officiel/login" className="btn-secondary w-full justify-center">
                Retour à la connexion
              </Link>
            </div>
          ) : (
            <>
              <p className="text-sm text-[var(--muted)] mb-6 leading-relaxed">
                Entre le numéro de téléphone associé à ton compte d'officiel. Nous t'enverrons un lien sécurisé par SMS.
              </p>
              <form onSubmit={submit} className="space-y-5">
                <div>
                  <label className="label block mb-2">Téléphone</label>
                  <input
                    type="tel"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    placeholder="514 555-1234"
                    disabled={loading}
                    autoFocus
                    className="input-line"
                    data-testid="official-forgot-phone-input"
                  />
                </div>
                {error && (
                  <div className="border-2 border-black p-3 text-xs bg-conflict-stripes-light font-mono" data-testid="official-forgot-error">
                    {error}
                  </div>
                )}
                <button type="submit" disabled={loading} className="btn-primary w-full justify-center" data-testid="official-forgot-submit-btn">
                  <Send size={14} strokeWidth={2.5} />
                  {loading ? "Envoi en cours…" : "Envoyer le SMS"}
                </button>
              </form>
              <p className="mt-6 pt-5 border-t border-[var(--border)] font-mono text-[10px] uppercase tracking-widest text-[var(--muted)]">
                Maximum 5 demandes par heure / par numéro.
              </p>
            </>
          )}
        </div>
        <div className="mt-4 text-center">
          <Link to="/officiel/login" className="font-mono text-[10px] uppercase tracking-widest text-[var(--muted)] hover:text-black inline-flex items-center gap-1">
            Retour à la connexion <ArrowRight size={11} strokeWidth={2.5} />
          </Link>
        </div>
      </div>
    </div>
  );
}
